var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import autosize from 'autosize';
import cx from 'classnames';
import { borderRadius } from '../theme/border-radius';
import { getFontSize, getTitleTag } from '../typography/utils';
const Preview = styled.div `
  padding: 12px;
  border-radius: ${borderRadius.md};
  color: var(--text-color-0);
  font-size: ${(props) => {
    const tag = getTitleTag(props);
    if (tag) {
        return `${getFontSize(tag)}px`;
    }
    return '12px';
}};
  appearance: none;
  border: none;
  box-shadow: none;
  background-color: transparent;
  box-sizing: border-box;
  outline: none;
  text-indent: 2px;
  width: 100%;
  line-height: 1.5;
  font-family: 'SF Pro Text', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;

  &::placeholder {
    color: var(--text-color-2);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px var(--focus-border-color);
    outline: none;
  }
`;
export const Editable = (_a) => {
    var { isEditing, value, onChange } = _a, props = __rest(_a, ["isEditing", "value", "onChange"]);
    const placeholder = value ? '' : props.placeholder;
    const editor = useRef(null);
    const tag = getTitleTag(props);
    const as = tag ? 'input' : 'textarea';
    useEffect(() => {
        if (as === 'textarea' && editor) {
            autosize(editor.current);
        }
    }, [editor, as]);
    return (React.createElement(Preview, Object.assign({}, props, { placeholder: placeholder, onInput: (e) => {
            onChange === null || onChange === void 0 ? void 0 : onChange(e.currentTarget.textContent);
        }, as: as, ref: editor, className: cx('editable', props.className), style: props.style })));
};
